<template>
  <div class="search-container">
    <div class="search-box">
      <div class="search-input-container" @mouseenter="innerInput" @mouseleave="leaveInput">
        <input
          type="text"
          id="search-id"
          class="search-input"
          :maxlength="searchType === 2 ? 17 : 1000"
          :style="searchType === 2 ? 'padding-left:50px;padding-right:80px' : ''"
          autocomplete="off"
          :placeholder="searchType === 1 ? '0键/Alt+0定位、Enter查询' : '请输入或粘贴17位VIN码'"
          v-model="keyword"
          @input="inputTxt"
          @focus="showHistoryPanel"
          @keyup.enter="performSearch"
        />
        <div class="imageUpload" v-if="searchType === 2">
          <button class="uploadBtn" @click="openImageUpload">
            <img :src="imageUploadSvg" alt="" />
          </button>
        </div>
        <img src="" class="imageUpload" alt="" />
        <div class="btn-box">
          <i
            :class="{ 'el-icon-circle-close': true, 'el-icon-circle-close-show': showClear }"
            id="clearIconId"
            @click="crearKeyword"
          ></i>
          <button class="search-btn" @click.stop="performSearch">
            <img :src="searchIconSvg" alt="" />
          </button>
          <button class="search-btn" v-show="searchType === 1" @click.stop="advancedSettingVisible = true">
            高级搜索
          </button>
        </div>
      </div>

      <div class="history-panel" :class="{ active: isHistoryPanelVisible }">
        <div class="history-header">
          <span class="history-title">搜索历史</span>
          <button class="clear-history" @click="clearAllHistory">清除全部</button>
        </div>

        <ul class="history-list" v-if="searchHistory.length > 0">
          <li class="history-item" v-for="item in searchHistory" :key="item.id" @click="selectHistory(item)">
            <span class="history-text">{{ item.content }}</span>
            <button class="delete-item" @click.stop="deleteHistoryItem(item.id)">×</button>
          </li>
        </ul>

        <div class="no-history" v-else>
          暂无搜索历史
        </div>
      </div>
    </div>
    <AdvancedSetting :visible.sync="advancedSettingVisible" @change="advancedQueryData"></AdvancedSetting>
    <VinImageUpload
      :img-upload-visible="imgUploadVisible"
      @close="flag => (imgUploadVisible = flag)"
      @change="getImgVinCode"
    ></VinImageUpload>
  </div>
</template>
<script>
import AdvancedSetting from "@/views/products/components/AdvancedSetting";
import searchIconSvg from "@/assets/svg/searchIcon.svg";
import imageUploadSvg from "@/assets/img/newProducts/imageUpload.svg";
import VinImageUpload from "./VinImageUpload.vue";
import {
  getSearchHistory,
  deleteGoodsHistory,
  deleteAllGoodsHistory,
  getGoodsHistoryContent
} from "@/api/goods/index.js";
import { mapState } from "vuex";
export default {
  components: {
    AdvancedSetting,
    VinImageUpload
  },
  props: {
    searchType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      imgUploadVisible: false,
      imageUploadSvg,
      keyword: "",
      isHistoryPanelVisible: false,
      searchHistory: [],
      oldSearchHistory: [],
      searchResults: [],
      advancedSettingVisible: false,
      searchIconSvg,
      showClear: false
    };
  },
  computed: {
    routerName() {
      return this.$route.name;
    },
    searchData() {
      return this.$store.getters["search/getSearchData"];
    },
    ...mapState("user", {
      userInfo: state => {
        return state.userInfo;
      }
    })
  },
  watch: {
    routerName: {
      handler(newV) {
        if (newV === "商品列表") {
          this.keyword = this.searchData.keyword;
        } else {
          this.keyword = "";
        }
      },
      immediate: true
    }
    // searchData: {
    //   handler(newV) {
    //     if (newV.keyword) {
    //       this.keyword = newV.keyword;
    //     }
    //   },
    //   immediate: true,
    //   deep: true
    // }
  },
  methods: {
    crearKeyword() {
      this.keyword = "";
      this.showClear = false;
      const searchInput = document.getElementById("search-id");
      if (searchInput) {
        searchInput.focus();
      }
      this.$nextTick(() => {
        this.showHistoryPanel();
      });
    },
    inputTxt() {
      if (this.searchType === 2) {
        this.keyword = this.keyword.replace(/[^a-zA-Z0-9]/g, "");
      }
      if (this.keyword) {
        this.showClear = true;
      } else {
        this.showClear = false;
      }
      if (this.keyword) {
        this.searchHistory = this.oldSearchHistory.filter(e => e.content.includes(this.keyword));
      } else {
        this.searchHistory = this.oldSearchHistory || [];
      }
    },
    leaveInput() {
      this.showClear = false;
    },
    innerInput() {
      if (this.keyword) {
        this.showClear = true;
      } else {
        this.showClear = false;
      }
    },
    clearInput() {
      this.keyword = "";
      this.searchHistory = [];
    },
    getImgVinCode(vin) {
      this.keyword = vin;
      this.$emit("searhKeyword", {
        keyword: this.keyword,
        historyId: 0,
        historyType: "",
        fromHistory: false
      });
    },
    openImageUpload() {
      this.imgUploadVisible = true;
    },
    advancedQueryData(data) {
      // this.queryData = {
      //   ...data,
      //   isPromotion: 0, // 促销: 0全部/1是/2否
      //   hasStock: this.queryData.hasStock, // 是否只查有货, true是
      //   isNormalBuy: false,
      //   resetCategory: true
      // };
      this.keyword = "";
      this.$store.commit("search/setSearchData", {
        ...data,
        keyword: this.keyword,
        type: -1,
        // 顶部搜索永远不带历史 areaId
        areaId: 0
      });
      if (this.routerName !== "商品列表") {
        this.$router.push({ path: "/new-products/product-list" });
      }
    },
    //获取搜索历史
    async getSearchHistoryData() {
      let type = "";
      if (this.searchType === 1) {
        type = "goodsKeyword";
      }
      if (this.searchType === 2) {
        type = "vin";
      }
      const res = await getSearchHistory(type);
      // this.searchHistory = res || [];
      this.oldSearchHistory = res || [];
      if (this.keyword) {
        this.searchHistory = this.oldSearchHistory.filter(e => e.content.includes(this.keyword));
      } else {
        this.searchHistory = res || [];
      }
    },
    // 显示历史记录面板
    async showHistoryPanel() {
      if (!this.userInfo.userId) {
        return;
      }
      await this.getSearchHistoryData();
      if (this.searchHistory.length > 0) {
        this.isHistoryPanelVisible = true;
      }
    },

    // 执行搜索（主动输入关键字，清空历史条件）
    performSearch() {
      if (this.searchType === 1) {
        if (this.keyword.trim().length < 2) {
          this.$message.error("关键字至少两位");
          return;
        }
      }
      if (this.searchType === 2) {
        this.$bus.$emit("clearCommonSearch");
        if (this.keyword.trim() === "") {
          this.$message.error("请输入vin");
          return;
        }
        if (this.keyword.length < 17) {
          this.$message.error("VIN码不正确");
          return;
        }
      }
      this.$emit("searhKeyword", {
        keyword: this.keyword,
        historyId: 0,
        historyType: "",
        fromHistory: false
      });
      this.isHistoryPanelVisible = false;
    },

    // 选择历史记录：搜索框展示文案；查件只传 historyId/historyType，不传 keyword
    async selectHistory(item) {
      this.isHistoryPanelVisible = false;
      // VIN 历史：keyword 从 history/content 接口取（第0条车型 vinCode），不用历史文本直查
      if (this.searchType === 2) {
        try {
          const res = await getGoodsHistoryContent({
            historyId: Number(item.id || 0),
            historyType: item.type || "vin",
            vmid: ""
          });
          const vin = (res.vehicles && res.vehicles[0] && res.vehicles[0].vinCode) || res.vin || "";
          if (!vin) {
            this.$message.error("未查询到该历史记录的VIN信息");
            return;
          }
          this.keyword = vin;
          this.$emit("searhKeyword", {
            keyword: vin,
            historyId: item.id,
            historyType: item.type || "vin",
            fromHistory: true
          });
        } catch (error) {
          if (error && error.message) {
            this.$message.error(error.message);
          }
        }
        return;
      }
      this.keyword = item.content;
      this.$emit("searhKeyword", {
        keyword: item.content,
        historyId: item.id,
        historyType: item.type || "goodsKeyword",
        fromHistory: true
      });
    },

    // 删除单个历史记录
    deleteHistoryItem(id) {
      const searchInput = document.getElementById("search-id");
      if (searchInput) {
        searchInput.focus();
      }
      this.$confirm("确定删除此条历史记录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      })
        .then(async () => {
          await deleteGoodsHistory(id);
          await this.getSearchHistoryData();
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },

    // 清除所有历史记录（关键字与VIN码历史分类型清除，接口参数不同）
    clearAllHistory() {
      // this.searchHistory = [];
      const searchInput = document.getElementById("search-id");
      if (searchInput) {
        searchInput.focus();
      }
      const historyType = this.searchType === 2 ? "vin" : "goodsKeyword";
      this.$confirm("确定删除所有历史记录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      })
        .then(async () => {
          await deleteAllGoodsHistory(historyType);
          await this.getSearchHistoryData();
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
  },
  mounted() {
    this.$bus.$on("inputFocus", () => {
      const searchInput = document.getElementById("search-id");
      if (searchInput) {
        searchInput.focus();
      }
      this.$nextTick(() => {
        this.showHistoryPanel();
      });
    });
    // 点击页面其他区域隐藏历史记录面板
    document.addEventListener("click", e => {
      const el = document.getElementById("search-id");
      const el2 = document.getElementById("clearIconId");
      const el3 = document.getElementById("search-control");
      if (el3) {
        if (el3.contains(e.target)) {
          if (this.searchHistory.length > 0) {
            this.isHistoryPanelVisible = true;
          }
          return;
        }
      }
      if (!el?.contains(e.target) && !el2?.contains(e.target)) {
        this.isHistoryPanelVisible = false;
      }
    });
    document.addEventListener("keydown", e => {
      // 如果弹窗打开，不处理0键和Alt键的聚焦功能
      if (this.imgUploadVisible || this.advancedSettingVisible) {
        return;
      }

      const activeElement = document.activeElement;
      const tagName = activeElement.tagName.toLowerCase();

      // 增强判断：检查是否在任何输入元素中
      const isTextInput = element => {
        const tag = element.tagName.toLowerCase();
        if (tag === "textarea") return true;
        if (tag === "input") {
          const type = element.type.toLowerCase();
          const textTypes = ["text", "password", "number", "email", "search", "tel", "url", "date", "time"];
          return textTypes.includes(type);
        }
        // 添加对 el-input-number 的判断
        if (element.classList && element.classList?.contains("el-input-number")) {
          return true;
        }
        return false;
      };

      // 如果当前在任何可输入元素中，直接返回
      if (
        isTextInput(activeElement) ||
        activeElement.isContentEditable ||
        tagName === "select" ||
        activeElement.closest(".el-input") ||
        activeElement.closest(".el-input-number")
      ) {
        return;
      }

      // 额外的安全判断：检查当前页面是否包含搜索框
      const searchInput = document.getElementById("search-id");
      if (!searchInput || !document.body?.contains(searchInput)) {
        return;
      }

      if (e.key === "0" || e.keyCode === 48) {
        e.preventDefault();
        if (searchInput) {
          searchInput.focus();
        }
        return;
      }
    });
  }
};
</script>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  // font-family: "Segoe UI", "Microsoft YaHei", sans-serif;
}
.el-icon-circle-close {
  color: #999;
  font-size: 22px;
  transition: all 0.3s ease;
  opacity: 0;
  &:hover {
    color: var(--color-primary);
    cursor: pointer;
  }
}
.el-icon-circle-close-show {
  opacity: 1;
}
.search-container {
  width: 100%;
  border-radius: 12px;
  // box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.search-box {
  position: relative;
  padding: 2px 0px 0px 0px;
}

.search-input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.search-input {
  width: 100%;
  padding: 12px 175px 12px 15px;
  border: 2px solid var(--color-primary);
  border-radius: 2px;
  font-size: 16px;
  outline: none;
  // transition: border-color 0.3s;
}
.imageUpload {
  position: absolute;
  left: 5px;
}
.btn-box {
  position: absolute;
  display: flex;
  align-items: center;
  column-gap: 8px;
  right: 5px;
}
.search-input:focus {
  border-color: var(--color-primary);
}
.uploadBtn {
  background: var(--color-primary);
  height: 39px;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px;
  cursor: pointer;
  transition: background 0.3s;
  font-size: 16px;
  font-weight: 500;
}
.search-btn {
  background: var(--color-primary);
  height: 39px;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 12px;
  cursor: pointer;
  transition: background 0.3s;
  font-size: 16px;
  font-weight: 500;
}

.search-btn:hover {
  background: var(--color-primary);
}

.history-panel {
  width: 100%;
  background-color: #fff;
  z-index: 1000;
  position: absolute;
  left: 0px;
  top: 100%;
  margin-top: 12px;
  border: 1px solid #e1e5ee;
  border-radius: 8px;
  overflow: hidden;
  max-height: 300px;
  overflow-y: auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  display: none;
}

.history-panel.active {
  display: block;
}

.history-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background: #f8f9fa;
  border-bottom: 1px solid #e1e5ee;
}

.history-title {
  font-weight: 600;
  color: #555;
}

.clear-history {
  background: none;
  border: none;
  color: #ff6b6b;
  cursor: pointer;
  font-size: 14px;
  transition: color 0.3s;
}

.clear-history:hover {
  color: #ff5252;
  text-decoration: underline;
}

.history-list {
  list-style: none;
}

.history-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  border-bottom: 1px solid #f1f1f1;
  cursor: pointer;
  transition: background 0.2s;
}

.history-item:hover {
  background: #f8f9fa;
}

.history-item:last-child {
  border-bottom: none;
}

.history-text {
  flex: 1;
  color: #333;
}

.delete-item {
  background: none;
  border: none;
  color: #999;
  cursor: pointer;
  padding: 5px;
  border-radius: 4px;
  transition: background 0.2s;
}

.delete-item:hover {
  background: #ffebee;
  color: #ff6b6b;
}

.no-history {
  padding: 20px;
  text-align: center;
  color: #999;
  font-style: italic;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.search-results {
  margin-top: 20px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
  display: none;
}

.search-results.active {
  display: block;
  animation: fadeIn 0.3s;
}

.results-title {
  font-weight: 600;
  margin-bottom: 10px;
  color: #555;
}

.result-item {
  padding: 8px 0;
  border-bottom: 1px solid #e1e5ee;
}

.result-item:last-child {
  border-bottom: none;
}
</style>
